import { useOrionTradingQuery } from './api/useOrionTradingQuery';

export const useOrionTrading = ({ clientId }) => {
  const queryInfo = useOrionTradingQuery({ clientId });

  if (!queryInfo.data) {
    return queryInfo;
  }

  const {
    IsTradingAllowed: isTradingAllowed,
    AllocationsScreenUrl: allocationsScreenUrl,
    TradesScreenUrl: tradesScreenUrl,
    ConfirmationsScreenUrl: confirmationsScreenUrl,
  } = queryInfo.data;

  const data = {
    isTradingAllowed,
    allocationsScreenUrl,
    tradesScreenUrl,
    confirmationsScreenUrl,
  };

  return { ...queryInfo, data };
};
